export default __webpack_public_path__ + "static/media/DNA term and Condition.9ba09cbd.pdf";